import { CircularProgress } from '@mui/material';
import AppAdminTable from 'components/AppAdminTable/AppAdminTable';
import ListPage from 'components/ListPage/ListPage';
import { TableColumns } from 'helpers/tableColumns';
import { useGetRooms } from 'hooks/useGetHotelRooms';
import { useRemoteResource } from 'hooks/useRemoteResource';
import roomsService from 'services/admin/roomsService';
import withRouter from 'hoc/withRouter';

const listConfig = [
    {
        key: "order",
        label: "#",
        render: (v, i) => i + 1
    },
    {
        key: 'number',
        label: 'Номер'
    },
    {
        key: 'roomTypeID',
        label: 'Тип комнаты',
        render: (v, i) => v.roomType?.code
    },
    {
        key: 'capacity',
        label: 'Количество мест',
        render: (v, i) => v.capacity
    },
    TableColumns.createdDate,
]

const RoomList = ({ router: { params: { hotelID } } }) => {
    const { data: rooms, isLoading, refetch } = useGetRooms({ hotelID: hotelID });

    const onDelete = async (u) => {
        await roomsService.delete(u.id);
        refetch();
    };

    if (isLoading) {
        return <div className="text-center"><CircularProgress></CircularProgress></div>
    }

    return (
        <ListPage pageTitle="Комнаты">
            <AppAdminTable
                columnConfig={listConfig}
                data={rooms?.data || []}
                onDelete={onDelete}
                loading={isLoading}
            />
        </ListPage>
    );
}


export default withRouter(RoomList);